export {
  availabilityStatusColors,
  labelColors,
  publicationPublishingStatusColors,
} from '@/components/user_catalog/publications/publicationColors';

export const PUBLICATION_SHOW_TABS = [
  'general',
  'availability',
  'formats',
  'reviews',
  'search',
  'activities',
] as const;

export type PublicationShowTab = (typeof PUBLICATION_SHOW_TABS)[number];

export const PUBLICATION_DEFAULT_TAB: PublicationShowTab = 'general';
